<template>
    <div>
      <div style="text-align: center">
        <h3>{{ form.id ? 'Edit Pengguna' : 'Tambah Pengguna' }}</h3>
      </div>
      <br />
      <form v-on:submit.prevent="addContact">
        <label>Nama Pengguna*</label>
        <input type="text" class="form-control" v-model="form.name" autofocus required />
        <br />
        <label>Nomor Handphone*</label>
        <input type="number" class="form-control" v-model="form.number" required />
        <br />
        <label>Email*</label>
        <input type="email" class="form-control" v-model="form.email" required />
        <br />
        <label>Password{{ !form.id ? '*' : '' }}</label>
        <input type="password" class="form-control" v-model="form.password" :required="!form.id" />
        <br />

        <label>Max Device*</label>
        <input type="number" class="form-control" v-model="form.max_device" required />
        <br />

        <label>Max CS*</label>
        <input type="number" class="form-control" v-model="form.max_cs" required />
        <br />

        <label>Max Link Rotator*</label>
        <input type="number" class="form-control" v-model="form.max_link_rotator" required />
        <br />


        <label>Expired At*</label>
        <input type="date" class="form-control" v-model="form.expired_at" required />
        <br />

        <label>Package (Optional)</label>
        <multiselect v-model="form.package_id"
            tag-placeholder="Pilih Package" placeholder="Cari Package"
            label="name" track-by="id" :options="packages" :multiple="false">
        </multiselect>
        <br />

        <label for="">Hak Akses</label>
        <select v-model="form.role" class="form-control" required>
          <option v-for="d in roles" :key="d.value" :value="d.value" >{{ d.text }}</option>
        </select>

        <br>
        <label for="">Status</label>
        <select v-model="form.status" class="form-control" required>
          <option value="0" >Tidak AKtif</option>
          <option value="1" >AKtif</option>
        </select>

        <br>

        <div class="button-group d-flex pt-25">
            <button type="submit" class="btn btn-primary btn-block btn-default btn-squared text-capitalize mx-auto d-block">
              simpan
            </button>
        </div>
      </form>
    </div>
  </template>
  
  <script>
  import Multiselect from 'vue-multiselect'
  
  export default {
    components: {
      Multiselect
    },
    props: {
      defaultValue: {
        type: Object,
        required: false,
      },
    },
    data() {
      return {
        form: {
          name: "",
          number: "",
          email: "",
          password: "",
          max_device: 0,
          max_cs: 0,
          max_link_rotator: 0,
          expired_at: "",
          role: "user",
          status: 0,
          package_id: null,
        },
        packages: [],
        roles: [
          {
            value: "user",
            text: "User",
          },
          {
            value: "admin",
            text: "Admin",
          },
          {
            value: "agency",
            text: "Agensi",
          },
        ]
      };
    },
    watch: {
      defaultValue: {
        handler: function (val) {
          if (val && val.id) {
            this.form = {...val};
            // Convert package_id (integer) to package object for multiselect after packages are loaded
            this.$nextTick(() => {
              if (this.packages.length > 0 && this.form.package_id) {
                this.setPackageFromId(this.form.package_id)
              }
            })
          } else if (!val || !val.id) {
            // Reset form when modal is closed or no default value
            this.form = {
              name: "",
              number: "",
              email: "",
              password: "",
              max_device: 0,
              max_cs: 0,
              max_link_rotator: 0,
              expired_at: "",
              role: "user",
              status: 0,
              package_id: null,
            }
          }
        },
        deep: true,
      },
      'form.package_id': {
        handler: function (newPackage) {
          if (newPackage && typeof newPackage === 'object') {
            this.autoFillFromPackage(newPackage)
          }
        },
        deep: true,
      },
    },
    async mounted() {
      // console.log('defaultValue', this.defaultValue)
      if (this.defaultValue && this.defaultValue.id) {
        this.form = {...this.defaultValue};
      }
      await this.getPackage()
      
      // Auto-fill if package_id already exists in form after packages are loaded
      if (this.form.package_id && this.packages.length > 0) {
        this.setPackageFromId(this.form.package_id)
        this.autoFillFromPackage(this.form.package_id)
      }
    },
    methods: {
      autoFillFromPackage(packageValue) {
        // Find package from packages array
        let packageId = typeof packageValue === 'object' ? packageValue.id : packageValue;
        let selectedPackage = this.packages.find(pkg => pkg.id === packageId);
        
        if (selectedPackage) {
          // Auto-fill max_device, max_cs, and max_link_rotator from package
          if (selectedPackage.max_device !== null && selectedPackage.max_device !== undefined) {
            this.form.max_device = selectedPackage.max_device;
          }
          if (selectedPackage.max_cs !== null && selectedPackage.max_cs !== undefined) {
            this.form.max_cs = selectedPackage.max_cs;
          }
          if (selectedPackage.max_link_rotator !== null && selectedPackage.max_link_rotator !== undefined) {
            this.form.max_link_rotator = selectedPackage.max_link_rotator;
          }
        }
      },
      async addContact(){
        try{
          if (this.form.id) {
            // EDIT MODE
            let updateData = {
              ...this.form,
              user: {
                id: this.form.id,
              },
              max_device: parseInt(this.form.max_device),
              max_cs: parseInt(this.form.max_cs),
              max_link_rotator:  parseInt(this.form.max_link_rotator),
              role: this.form.role,
              status: parseInt(this.form.status),
            }
            
            // Convert package_id to integer if it's an object (from multiselect)
            if (this.form.package_id && typeof this.form.package_id === 'object') {
              updateData.package_id = this.form.package_id.id
            } else if (this.form.package_id) {
              updateData.package_id = this.form.package_id
            } else {
              updateData.package_id = null
            }
            
            let response = await this.$store.dispatch('admin_user_update', updateData)
            this.$toast.success(response.data.message);
            this.$root.$emit("toggle_modal", "modal_user")
            this.$root.$emit("refresh_table", true)
            return;
          }

          // CREATE MODE
          let createData = {
            ...this.form,
            max_device: parseInt(this.form.max_device),
            max_cs: parseInt(this.form.max_cs),
            max_link_rotator:  parseInt(this.form.max_link_rotator),
            role: this.form.role,
            status: parseInt(this.form.status),
          }
          
          // Add package_id if selected
          if (this.form.package_id && typeof this.form.package_id === 'object') {
            createData.package_id = this.form.package_id.id
          } else if (this.form.package_id) {
            createData.package_id = this.form.package_id
          }
          
          let response = await this.$store.dispatch('admin_user_create', createData)
          this.$toast.success(response.data.message);
          this.$root.$emit("toggle_modal", "modal_user")
          this.$root.$emit("refresh_table", true)
        }catch(err){
          console.log('error', err)
          this.$toast.error(err.response.data.message);
        }
      },
      async getPackage() {
        try {
          let p = await this.$store.dispatch('package_list')
          this.packages = p.data.data.packages ?? []
          
          // After packages are loaded, set package object if package_id exists
          if (this.form.package_id && this.packages.length > 0) {
            this.setPackageFromId(this.form.package_id)
          }
        } catch (err) {
          this.$toast.error(err.response.data.message);
        }
      },
      setPackageFromId(packageId) {
        // Convert package_id (integer) to package object for multiselect
        let id = typeof packageId === 'object' ? packageId.id : packageId;
        let selectedPackage = this.packages.find(pkg => pkg.id === id);
        if (selectedPackage) {
          this.form.package_id = selectedPackage;
        }
      },
    },
  };
  </script>
  
  <style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
  